import axios from "axios"
import config from "src/common/config"

const AXIOS_CONFIG = {
  baseURL: config.get("APP_WWW_URL"),
}

export default axios.create(AXIOS_CONFIG)
